import React from 'react';
import { Translate } from 'react-localize-redux';
import css from './BadFilterCombination.css';
import BadFilterIcon from '../../../resources/icons/creatives/bad_filter_combination.svg';

export const BAD_FILTER_TITLE = 'STATIC.PAGES.CREATIVE_GALLERY.BAD_FILTER_COMBINATION.TITLE';
export const BAD_FILTER_SUBTITLE = 'STATIC.PAGES.CREATIVE_GALLERY.BAD_FILTER_COMBINATION.SUBTITLE';

const BadFilterCombination = () => (
    <div className={css.badFilterCombination}>
        <BadFilterIcon />
        <div className={css.title}>
            <Translate id={BAD_FILTER_TITLE} />
        </div>
        <div className={css.subtitle}>
            <Translate id={BAD_FILTER_SUBTITLE} />
        </div>
    </div>
);

BadFilterCombination.propTypes = {};

export default BadFilterCombination;
